import { withInstall } from '@/utils'
import ClueMerge from './src/clueMerge.vue'
export default withInstall(ClueMerge)
